import { type ReactNode } from 'react';
import { WorldSelectionSheetContext } from './useWorldSelectionSheet';

/**
 * Provider for the global WorldSelectionSheet trigger context. Owned
 * by `AppShell` so the sheet's open/close lifecycle stays in one
 * place; descendants invoke the trigger via `useWorldSelectionSheet()`
 * (see `./useWorldSelectionSheet.ts`).
 */

export interface WorldSelectionSheetProviderProps {
  children: ReactNode;
  /** Trigger that opens the sheet — owned by the consumer (typically AppShell). */
  openSheet: () => void;
}

export function WorldSelectionSheetProvider({
  children,
  openSheet,
}: WorldSelectionSheetProviderProps) {
  return (
    <WorldSelectionSheetContext.Provider value={{ openSheet }}>
      {children}
    </WorldSelectionSheetContext.Provider>
  );
}
